var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "linkedin",
    width: 26,
    height: 26,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgEAQAAACJ4248AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAAAGAAAABgAPBrQs8AAAAHdElNRQflBwUMHTGoC5nxAAABxUlEQVRYw+2VPS8EURSGnzMRS0LotCsaX1EoRKLRKIgfoBKJQtQqv0A0Eq1GQ0iEiFDMKrQUW4pKorUJIWuJTdxXsdn4mrtI7m41bzdzznvPc9/J3AuA1NcnxbH08iIVCtL6ulxbG41QZXippO9y5+dyTU0NAIhj+eQWFhoA8PzsBdDWVr3nR6hU8pdr1UIB2M6OLxvY3a03AHLt7VI+/zP+1dW6DwesAtHcjC0uwvg4FItoe9uiOG4EQCqTBgbQ8HBy+ejIosfH6pPcxATW3f2jTTc3FuVyAFJnJ8zPo6kpyGZBwgoFuL6Gw0N0fGzR6+uHV8vL/nOgv//LHLe/n9x3cFBZa25OKhZVS+7qSm5kpLpmFCpKaWkJNjfhlzvEenuxXK66uTAAGhqClZW/Gzo6YGMDIMxlYz09/zeNjUmjo8E+wVeVy+Dc732Tk2EBtLcHg4NmmQxqbYXpabi99RuCJnB2hs3MmF1eAlhULpudnKDZWb8nmw0HoLU1s4TY7fQUHh6STV1dARO4uEh6ayahfD7Z09ISCEDC7u+9Zbu7Sy5kMoEAnp7M3t789U9H7zeFS6Cm/L9knc6BvysFSAFSgBTgHQJ9VnB7EP0rAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIxLTA3LTA1VDEyOjI5OjQ5KzAwOjAwYyvZcAAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMS0wNy0wNVQxMjoyOTo0OSswMDowMBJ2YcwAAAAASUVORK5CYII="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.e552d29f3da0dcd0cca5c03671580f77.svg";
export { ForwardRef as ReactComponent };